import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import { ACCESSIBLE_CHANNEL_TYPE, ENDPOINTS } from '../app.config';
import Utils from '../app.utilities';
import { CompanyService } from '../company.service';
import { UserInfoService } from '../shared/user-info.service';
import { TranslateService } from '@ngx-translate/core';

const utilities = new Utils();

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  // Is already provided in ../app.module.ts
  //  but the UserInfoService, in the constructor, needs access to ActivatedRoute.params
  //  https://stackoverflow.com/questions/39977962/angular-2-0-2-activatedroute-is-empty-in-a-service
  providers: [UserInfoService]
})
export class UsersComponent implements OnInit {
  channelsList = [];
  selectedChannels = [];
  dropdownSettings = {};
  newUser = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    passwordRepeat : '',
    office: '',
    is_editor: true,
    is_lpp_editor: false,
    roleid: ''
  };
  selectedrole = 0;
  errors = [];
  currentPage = 1;
  usersTotal: number;
  usersPerPage: number;
  totalPages: number;
  gettingUsersInProgress: boolean;
  companyId: string;
  users: any;
  sub: any;
  companyService: any;
  companyName: string;
  userRole: string;
  route: ActivatedRoute;
  toaster: ToasterService;
  businesOwnerName : string;
  businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');
  selectChannelsLabel = '';

  // Messages
  user_successfully_added: string;
  password_changed_successfully: string;
  error_changing_password: string;
  user_successfully_deleted: string;
  user_error_erasing: string;

  constructor(
    route: ActivatedRoute,
    toaster: ToasterService,
    companyService: CompanyService,
    private translate: TranslateService,
    private userInfoService: UserInfoService,
  ) {
    this.route = route;
    this.toaster = toaster;
    this.companyId = '';
    this.newUser = {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      passwordRepeat : '',
      office: '',
      is_editor: false,
      is_lpp_editor:false,
      roleid: ''
    };
    this.companyService = companyService;
  }

  ngOnInit() {
    this.gettingUsersInProgress = false;
    this.channelsList = [];
    this.selectedChannels = [];
    // Translations
    this.translate.stream('SHARED.SelectBox.select_channels').subscribe((res: string) => {
      this.dropdownSettings = {
        singleSelection: false,
        enableCheckAll: false,
        text: res,
        selectAllText: 'Select All',
        unSelectAllText: 'Remove All',
        enableSearchFilter: false,
        classes: 'item-separation c-token',
      };
    });
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.companyService.setCompanyId(this.companyId);
      this.getUsers();
      this.getCompanyInfo();
      this.getUserInfo();
    });

    // Messages translations
    this.translate.stream('SHARED.Messages.user_successfully_added').subscribe((res: string) => {
      this.user_successfully_added = res;
    });
    this.translate.stream('SHARED.Messages.password_changed_successfully').subscribe((res: string) => {
      this.password_changed_successfully = res;
    });
    this.translate.stream('SHARED.Messages.error_changing_password').subscribe((res: string) => {
      this.error_changing_password = res;
    });
    this.translate.stream('SHARED.Messages.user_successfully_deleted').subscribe((res: string) => {
      this.user_successfully_deleted = res;
    });
    this.translate.stream('SHARED.Messages.user_error_erasing').subscribe((res: string) => {
      this.user_error_erasing = res;
    });
  }

  initPaging(response) {
    const _self = this;
    _self.usersTotal = parseInt(response.headers['total'], 10);
    _self.usersPerPage = parseInt(response.headers['per-page'], 10);
    _self.totalPages = Math.floor(_self.usersTotal % _self.usersPerPage) === 0
      ? _self.usersTotal / _self.usersPerPage
      : Math.floor(_self.usersTotal / _self.usersPerPage) + 1;
      // Pagination case
      //   Example: companiesTotal = 11, companiesPerPage = 10, currentPage = 2, only 1 company on the page
      //   After 11 company is deleted, page 2 doesn't exist anymore
      //   Therefore _currentPage needs to be reduced with -1
      if( _self.currentPage > _self.totalPages){
        _self.currentPage--;
      }
  }

  loadDevices(page, isDisabled) {
    if (!isDisabled && !this.gettingUsersInProgress) {
      this.currentPage = page;
      this.getUsers();
    }
  }

  getUserInfo() {
    const _self = this;

    this.userInfoService.getInformations()
    .subscribe( info => {
      _self.userRole         = info.userRole;
      _self.companyName      = info.companyName;
      _self.businesOwnerName = info.businesOwnerName;
    });
  }

  generateChannelsList(channels) {
    const channelsList = [];
    for (const item of channels) {
      channelsList.push({
        id: item.id,
        itemName: item.name,
      });
    }
    return channelsList;
  }

  getCompanyInfo() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_COMPANIES + '/' + _self.companyId)
      .then(response => {
        _self.companyName = response.data.name;
        _self.channelsList = _self.generateChannelsList(response.data.channels);
      });
  }

  validateNewUser() {
    this.errors = [];
    if (!this.newUser.first_name) {
      this.errors.push('first_name');
    }
    if (!this.newUser.last_name) {
      this.errors.push('last_name');
    }
    if (!this.newUser.email) {
      this.errors.push('email');
    }
    if (!this.newUser.password) {
      this.errors.push('password');
    }
    // if(!this.newUser.is_editor && !this.newUser.is_lpp_editor)
    // {
    //   this.newUser.is_editor = true;
    // }
    return this.errors.length === 0;
  }

  connectChannel(user) {
    const _self = this;
    for (const channel of this.selectedChannels) {
      axios
        .post(ENDPOINTS.CHANNEL_ACCESS, {
          accessible_id: user.id,
          accessible_type: ACCESSIBLE_CHANNEL_TYPE,
          channel_id: channel.id,
        })
        .then(
          response => {
            _self.getUsers();
          },
          error => {
            _self.getUsers();
          },
        );
    }
  }

  addNewUser() {
    const _self = this;

    const isUserValid = this.validateNewUser();
    if (isUserValid) {
      axios
        .post(
          ENDPOINTS.POST_USER.replace(':companyId', this.companyId),
          this.newUser,
        )
        .then(
          response => {
            _self.newUser = {
              first_name: '',
              last_name: '',
              email: '',
              password: '',
              passwordRepeat: '',
              office: '',
              is_editor: false,
              is_lpp_editor:false,
              roleid:''
            };
            _self.connectChannel(response.data);
            _self.getUsers();
            _self.toaster.pop('success', this.user_successfully_added);
          },
          error => {
            _self.toaster.pop('error', error.response.data.message);
          },
        );
    }
  }

  onItemSelect(channel, user?) {
    const _self = this;
    if (user) {
      axios.post(ENDPOINTS.CHANNEL_ACCESS, {
        accessible_id: user.id,
        accessible_type: ACCESSIBLE_CHANNEL_TYPE,
        channel_id: channel.id,
      });
    }
  }
  OnItemDeSelect(channel, user?) {
    const _self = this;
    if (user) {
      axios.delete(ENDPOINTS.CHANNEL_ACCESS, {
        data: {
          accessible_id: user.id,
          accessible_type: ACCESSIBLE_CHANNEL_TYPE,
          channel_id: channel.id,
        },
      });
    }
  }

  generatePages() {
    if (!this.totalPages) {
      return [];
    }
    const arr = [];
    for (let i = 0; i < this.totalPages; i++) {
      arr.push(i + 1);
    }
    return arr;
  }

  getUsers() {

    const _self = this;
    if (_self.gettingUsersInProgress) {
      return;
    }
    _self.gettingUsersInProgress = true;
    axios.get(ENDPOINTS.GET_USERS.replace(':companyId', _self.companyId)).then(
      response => {
        _self.initPaging(response);
        axios
          .get(
            ENDPOINTS.GET_USERS.replace(':companyId', _self.companyId) +
              '?page=' +
              _self.currentPage +
              '&per_page=' +
              _self.usersPerPage,
          )
          .then(
            responseWIthPaging => {
              _self.users = responseWIthPaging.data;
              _self.gettingUsersInProgress = false;

              for (const user of _self.users) {
                if(user.is_editor)
                {
                  user.roleid = 0;
                }
                else if(user.is_lpp_editor)
                {
                  user.roleid = 1;
                }
                else if(!user.is_editor && !user.is_lpp_editor){
                  user.roleid = 2;
                }
                user.selectedChannels = _self.generateChannelsList(
                  user.channels,
                );
              }
            },
            err => {
              _self.gettingUsersInProgress = false;
            },
          );
      },
      error => {
        _self.gettingUsersInProgress = false;
      },
    );
  }

  updateUser(user) {

    if(user.roleid==0)
    {
      user.is_editor = true;
      user.is_lpp_editor=false;
      this.newUser.is_editor = true;
      this.newUser.is_lpp_editor =  false;
    }
    else if(user.roleid == 1)
    {
      user.is_editor = false;
      user.is_lpp_editor=true;
      this.newUser.is_editor = false;
      this.newUser.is_lpp_editor =  true;
    }
    else if(user.roleid ==2)
    {
      user.is_editor = false;
      user.is_lpp_editor = false;
      this.newUser.is_lpp_editor = false;
      this.newUser.is_editor = false;
    }
    const _self = this;
    if ( !this.isPasswordSubmitOff(user) ) {
      axios
        .put(
          ENDPOINTS.UPDATE_USER
            .replace(':companyId', _self.companyId)
            .replace(':userId', user.id) + '/password',
          {
            password: user.password,
            password_confirmation: user.passwordRepeat,
          },
        )
        .then(
          response => {
            _self.resetUserFieldPasswords(user);
            this.toaster.pop('success', this.password_changed_successfully);
          },
          error => {
            _self.resetUserFieldPasswords(user);
            this.toaster.pop('error', this.error_changing_password);
          },
        );
    }
    axios.put(
      ENDPOINTS.UPDATE_USER
        .replace(':companyId', _self.companyId)
        .replace(':userId', user.id),
      user,
    );
  }

  deleteUser(user) {
    const _self = this;
    axios
      .delete(
        ENDPOINTS.DELETE_USER
          .replace(':companyId', _self.companyId)
          .replace(':userId', user.id),
      )
      .then(
        response => {
          _self.getUsers();
          _self.toaster.pop('success', this.user_successfully_deleted);
        },
        error => {
          _self.toaster.pop('error', this.user_error_erasing);
        },
      );
  }

  isPasswordSubmitOff(user){
    if(typeof user.password === "string" && user.password.length){
      return user.password !== user.passwordRepeat;
    } else {
      return true;
    }
  }
  resetUserFieldPasswords(user){
    user.password='';
    user.passwordRepeat='';
  }

  setRole()
  {

    if(this.selectedrole==0)
    {
      this.newUser.is_editor = true;
      this.newUser.is_lpp_editor = false;
    }
    else if(this.selectedrole==1)
    {
      this.newUser.is_editor = false;
      this.newUser.is_lpp_editor = true;
    }
    else if(this.selectedrole==2)
    {
      this.newUser.is_editor = false;
      this.newUser.is_lpp_editor = false;
    }
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/users/users.component.ts